import React from 'react'
import t from '../../translations/i18n'

export default function Faq () {
  return (
    <>

      <section id="faq" className="faq section-bg">
        <div className="container" data-aos="fade-up">

          <div className="section-title">
            <h2>{t('sections.qa_tittle')}</h2>
            <p>{t('sections.qa_subtittle')}</p>
          </div>

          <ul className="faq-list" data-aos="fade-up" data-aos-delay="100">
            <li>
              <div data-bs-toggle="collapse" className="collapsed question" href="#faq1">{t('sections.qa_q1')}<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></div>
              <div id="faq1" className="collapse" data-bs-parent=".faq-list">
                <p>
                  {t('sections.qa_a1')}
                </p>
              </div>
            </li>

            <li>
              <div data-bs-toggle="collapse" href="#faq2" className="collapsed question">{t('sections.qa_q2')}<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></div>
              <div id="faq2" className="collapse" data-bs-parent=".faq-list">
                <p>
                  {t('sections.qa_a2')}
                </p>
              </div>
            </li>

            <li>
              <div data-bs-toggle="collapse" href="#faq3" className="collapsed question">{t('sections.qa_q3')}<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></div>
              <div id="faq3" className="collapse" data-bs-parent=".faq-list">
                <p>
                  {t('sections.qa_a3')}
                </p>
              </div>
            </li>

            <li>
              <div data-bs-toggle="collapse" href="#faq4" className="collapsed question">{t('sections.qa_q4')}<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></div>
              <div id="faq4" className="collapse" data-bs-parent=".faq-list">
                <p>
                  {t('sections.qa_a4')}
                </p>
              </div>
            </li>

            <li>
              <div data-bs-toggle="collapse" href="#faq5" className="collapsed question">{t('sections.qa_q5')}<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></div>
              <div id="faq5" className="collapse" data-bs-parent=".faq-list">
                <p>
                  {t('sections.qa_a5')}
                </p>
              </div>
            </li>

            <li>
              <div data-bs-toggle="collapse" href="#faq6" className="collapsed question">{t('sections.qa_q6')}<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></div>
              <div id="faq6" className="collapse" data-bs-parent=".faq-list">
                <p>
                  {t('sections.qa_a6')}
                </p>
              </div>
            </li>

            <li>
              <div data-bs-toggle="collapse" href="#faq7" className="collapsed question">{t('sections.qa_q7')}<i className="bi bi-chevron-down icon-show"></i><i className="bi bi-chevron-up icon-close"></i></div>
              <div id="faq7" className="collapse" data-bs-parent=".faq-list">
                <p>
                  {t('sections.qa_a7')}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </>
  )
}
